module.exports = __webpack_public_path__ + "img/jardin-plantes-paris.3cd6ecb0.jpg";